module.exports = __webpack_public_path__ + "img/package.9dc09466.png";